import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import TopBar from "@/components/site/TopBar";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import CategoryTiles from "@/components/site/CategoryTiles";
import ProductGrid from "@/components/site/ProductGrid";
import { Promises, Testimonials, StripMarquee } from "@/components/site/Sections";
import Footer from "@/components/site/Footer";
import CartDrawer from "@/components/site/CartDrawer";
import { EDIT_PRODUCTS, NEW_ARRIVALS, BUDGET_PICKS } from "@/mock";
import {
  ShippingPage,
  ReturnsPage,
  InstallationPage,
  WarrantyPage,
  PrivacyPage,
  TermsPage,
  RefundPolicyPage,
  CancellationPage,
} from "@/pages/Policies";
import ContactPage from "@/pages/ContactPage";

const Home = () => (
  <div className="min-h-screen bg-[#0b0b0c] text-[#f4ead5]">
    <TopBar />
    <Header />
    <Hero />
    <CategoryTiles />
    <ProductGrid
      id="edit"
      eyebrow="Handpicked"
      title="The"
      italic="Edit"
      items={EDIT_PRODUCTS}
    />
    <StripMarquee />
    <ProductGrid
      id="new-arrivals"
      eyebrow="Just landed"
      title="New"
      italic="Arrivals"
      items={NEW_ARRIVALS}
    />
    <ProductGrid
      id="budget"
      eyebrow="Everyday essentials"
      title="Budget"
      italic="Picks"
      items={BUDGET_PICKS}
      seeAllLabel="View all"
    />
    <Promises />
    <Testimonials />
    <Footer />
    <CartDrawer />
  </div>
);

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shipping" element={<ShippingPage />} />
          <Route path="/returns" element={<ReturnsPage />} />
          <Route path="/installation" element={<InstallationPage />} />
          <Route path="/warranty" element={<WarrantyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/refunds" element={<RefundPolicyPage />} />
          <Route path="/cancellation" element={<CancellationPage />} />
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
